import store from '../store'
import {CommonApi} from '../request/common_api'
import {ConsumeApi} from '../request/Consume/consume_api'

function tvNoList (merchid = '', isfullscreen = '', termType = 'emdTermType') {
  // 终端号列表
  ConsumeApi.consumeDropDownList('004', {merchid: merchid, termType: termType, isfullscreen: isfullscreen}).then(res => {
    if (res.retCode === '0000') {
      store.commit('program/setTVNoList', res.BizBodyMsg.codeList)
    }
  })
}

function screenPositionList () {
  // 电子餐牌屏位位置
  if (store.state.program.screenPositionList.length) {
    return
  }
  CommonApi.getTableList('EMDSCREENPOSI').then(res => {
    if (res.retCode === '0000') {
      store.commit('program/setScreenPositionList', res.BizBodyMsg.typeList[0].codeList)
    }
  })
}

function programList () {
  // 节目下拉框
  ConsumeApi.consumeDropDownList('011', {}).then(res => {
    if (res.retCode === '0000') {
      store.commit('program/setProgramList', res.BizBodyMsg.codeList)
    }
  })
}

const getProgramDropDownList = {programList, screenPositionList, tvNoList}

export {getProgramDropDownList}



// WEBPACK FOOTER //
// ./src/util/ProgramDropDownList.js